import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../modules/auth/useAuth";

const Home = (): JSX.Element => {
  const auth = useAuth();

  React.useEffect(() => {
    // If authenticated, go to dashboard
    if (auth.isAuthenticated) {
      // We use window.location or navigate based on preference.
      // Here since this is a route component, we can assume wrapper handles it,
      // but let's use a nice Navigate or imperative redirect.
      // Actually, returning <Navigate> is cleaner in render.
    }
  }, [auth.isAuthenticated]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, redirect to Login page (or show landing page)
  return <Navigate to="/login" replace />;
};

export default Home;
